module.exports = __webpack_public_path__ + "static/google-img-c2010e9c6662e636a8c02b9b6b05796b.jpeg";